import { SendToWpButtonController } from "./send-to-wp-button.controller";

angular
    .module("thor.loki.send-to-wp-button.component", [])
    .component("sendToWpButton", {
        bindings: {
            isItemPast: "<",
            item: "<",
            sale: "<"
        },
        controller: SendToWpButtonController,
        template: require("./send-to-wp-button.html")
    });
